import { Injectable } from '@angular/core';
import { driver, type Config, type DriveStep } from 'driver.js';

@Injectable({ providedIn: 'root' })
export class FaxAuditTourService {
  start(): void {
    const steps: DriveStep[] = [
      {
        element: '#tour-fax-header',
        popover: {
          title: 'Fax Audit',
          description:
            'Use this screen to audit fax accounts across NS domains. You can view account IDs, client types, and fax types — and update client types individually or in bulk.',
          side: 'bottom',
          align: 'start',
        },
      },
      {
        element: '#tour-fax-domain-selector',
        popover: {
          title: 'Domain Selector',
          description:
            'Select one or more domains and click <strong>Get information</strong> to load fax accounts from NetSapiens.',
          side: 'bottom',
          align: 'start',
        },
      },
      {
        element: '#tour-fax-results',
        popover: {
          title: 'Account Table',
          description:
            'Each domain gets its own table. Select accounts with the checkboxes and click the <strong>upload</strong> button to update their client type in bulk. The per-row upload icon updates a single account. Use search, field filters, and column toggles to narrow the list.',
          side: 'top',
          align: 'start',
        },
      },
    ];

    const config: Config = {
      showProgress: true,
      nextBtnText: 'Next',
      prevBtnText: 'Back',
      doneBtnText: 'Done',
      progressText: '{{current}} of {{total}}',
      steps,
    };

    driver(config).drive();
  }
}
